import script from "./ReviewsTable.vue?vue&type=script&setup=true&lang=js"
export * from "./ReviewsTable.vue?vue&type=script&setup=true&lang=js"

import "./ReviewsTable.vue?vue&type=style&index=0&id=434fc54d&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-434fc54d"]])

export default __exports__